import React from 'react';
import { AreaChart, Card, Text } from '@tremor/react';
import { ParkingStats } from '../../types';

interface OccupancyChartProps {
  stats: ParkingStats;
}

const OccupancyChart: React.FC<OccupancyChartProps> = ({ stats }) => {
  // Format data for the chart
  const chartData = stats.hourlyStats.map((data) => ({
    hour: `${data.hour}:00`,
    Occupied: data.occupied,
  }));

  return (
    <Card>
      <Text className="text-contentColor font-medium text-lg">Hourly Occupancy</Text>
      <Text className="text-contentColor">Number of vehicles throughout the day</Text>
      <AreaChart
        className="h-72 mt-4"
        data={chartData}
        index="hour"
        categories={['Occupied']}
        colors={['blue']}
        valueFormatter={(value) => `${value} vehicles`}
        showLegend={false}
        showGridLines={false}
        showAnimation={true}
      />
    </Card>
  );
};

export default OccupancyChart;